module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.child) ? _c('div', [_c('control', {
    attrs: {
      "label": "Child Dependency Until",
      "for": "method"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerLifeExpectancy.method),
      expression: "innerLifeExpectancy.method"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "method",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.innerLifeExpectancy, "method", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcChildDependentAge]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dependent_until_16"
    }
  }, [_vm._v("Aged 16")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dependent_until_18"
    }
  }, [_vm._v("Aged 18")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dependent_until_21"
    }
  }, [_vm._v("Aged 21")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dependent_until_custom"
    }
  }, [_vm._v("Specify custom dependency")])])]), _vm._v(" "), (_vm.innerLifeExpectancy.method === 'dependent_until_custom') ? _c('control', {
    attrs: {
      "label": "Age Dependency Ends",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerLifeExpectancy.child.youthCutOffAge),
      expression: "innerLifeExpectancy.child.youthCutOffAge"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number"
    },
    domProps: {
      "value": (_vm.innerLifeExpectancy.child.youthCutOffAge)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerLifeExpectancy.child, "youthCutOffAge", $event.target.value)
      }, _vm.calcChildDependentDate]
    }
  })]) : _vm._e()], 1) : _c('div', [_c('control', {
    attrs: {
      "label": _vm.label,
      "for": "method1",
      "icon-space": !_vm.dayOne
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerLifeExpectancy.method),
      expression: "innerLifeExpectancy.method"
    }],
    attrs: {
      "id": "method1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.innerLifeExpectancy, "method", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcAgeAtDeath]
    }
  }, [(this.person.gender === null) ? _c('option', {
    attrs: {
      "value": "ogden_table",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]) : _vm._e(), _vm._v(" "), (this.person.gender === 'male') ? _c('option', {
    attrs: {
      "value": "ogden_table"
    }
  }, [_vm._v("Odgen Table 1")]) : _vm._e(), _vm._v(" "), (this.person.gender === 'female') ? _c('option', {
    attrs: {
      "value": "ogden_table"
    }
  }, [_vm._v("Odgen Table 2")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "years_and_months"
    }
  }, [_vm._v("Enter Years/Months")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "enter_date"
    }
  }, [_vm._v("Enter Date")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "age_at_death"
    }
  }, [_vm._v("Enter Age At Death (years)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "percentage_of_normal_life_expectancy"
    }
  }, [_vm._v("% of Normal Life Expectancy")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "percentage_reduction_in_normal_life_expectancy"
    }
  }, [_vm._v("% Reduction in Normal Life Expectancy")])])]), _vm._v(" "), (_vm.innerLifeExpectancy.method == 'years_and_months') ? _c('control', {
    attrs: {
      "label": "Enter Years/Months From Today",
      "icon-space": !_vm.dayOne
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerLifeExpectancy.yearsAndMonths.years),
      expression: "innerLifeExpectancy.yearsAndMonths.years",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "years"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.innerLifeExpectancy.yearsAndMonths, "years", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcAgeAtDeath]
    }
  }, _vm._l((76), function(year) {
    return _c('option', {
      domProps: {
        "value": year - 1
      }
    }, [_vm._v(_vm._s(year - 1) + " year(s)")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerLifeExpectancy.yearsAndMonths.months),
      expression: "innerLifeExpectancy.yearsAndMonths.months",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "months"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.innerLifeExpectancy.yearsAndMonths, "months", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcAgeAtDeath]
    }
  }, _vm._l((12), function(month) {
    return _c('option', {
      domProps: {
        "value": month - 1
      }
    }, [_vm._v("\n                            " + _vm._s(month - 1) + " month(s)\n                        ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.innerLifeExpectancy.method == 'percentage_of_normal_life_expectancy') ? _c('control', {
    attrs: {
      "label": "Percentage of Normal Life Expectancy",
      "for": "percentage_of_normal_life_expectancy",
      "before-after": "percent",
      "icon-space": !_vm.dayOne
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.percentageOfNormalLifeExpectancy),
      expression: "percentageOfNormalLifeExpectancy",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.innerLifeExpectancy.method !== 'percentage_of_normal_life_expectancy',
      "required": "",
      "max": "100",
      "min": "1",
      "name": "percentage_of_normal_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.percentageOfNormalLifeExpectancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.percentageOfNormalLifeExpectancy = _vm._n($event.target.value)
      }, _vm.calcAgeAtDeath],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('percentage_of_normal_life_expectancy')
    }
  }, [_vm._v("\n                The percentage of normal life expectancy must be number between 1 and 100\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.innerLifeExpectancy.method == 'percentage_reduction_in_normal_life_expectancy') ? _c('control', {
    attrs: {
      "label": "Percentage Reduction in Normal Life Expectancy",
      "for": "percentage_reduction_in_normal_life_expectancy",
      "icon-space": !_vm.dayOne,
      "before-after": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.percentageReductionInNormalLifeExpectancy),
      expression: "percentageReductionInNormalLifeExpectancy",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.innerLifeExpectancy.method !== 'percentage_reduction_in_normal_life_expectancy',
      "required": "",
      "max": "100",
      "min": "1",
      "name": "percentage_reduction_in_normal_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.percentageReductionInNormalLifeExpectancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.percentageReductionInNormalLifeExpectancy = _vm._n($event.target.value)
      }, _vm.calcAgeAtDeath],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('percentage_reduction_in_normal_life_expectancy')
    }
  }, [_vm._v("\n                The percentage reduction in normal life expectancy must be number between 1 and 100\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.innerLifeExpectancy.method == 'enter_date') ? _c('control', {
    attrs: {
      "label": "Expected End of Life Date",
      "for": "expected_date_of_death",
      "icon-space": !_vm.dayOne
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:expected_date_of_death.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "expected_date_of_death",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.innerLifeExpectancy.method != 'enter_date'
    },
    on: {
      "input": _vm.calcAgeAtDeath
    },
    model: {
      value: (_vm.innerLifeExpectancy.dateOfDeathIsAssumed),
      callback: function($$v) {
        _vm.$set(_vm.innerLifeExpectancy, "dateOfDeathIsAssumed", $$v)
      },
      expression: "innerLifeExpectancy.dateOfDeathIsAssumed"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('expected_date_of_death')
    }
  }, [_vm._v("\n                The deceased's expected end of life is required and must be in the format DD/MM/YYYY\n            ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Expected Age at End of Life (Years)",
      "for": "life_age_at_death",
      "icon-space": !_vm.dayOne,
      "modal-name": 'life_age_at_death_modal_' + _vm.uniqueId,
      "endpoint": _vm.innerLifeExpectancy.method,
      "payload": _vm.lifeExpectancyModal,
      "tip-icon": _vm.lifeAgeAtDeathIcon,
      "tip-show": _vm.stepValid,
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "life_age_at_death",
      "before-after": _vm.dayOne ? 'years-old-on-dark' : 'years-old'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ageAtDeath),
      expression: "ageAtDeath",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.innerLifeExpectancy.method !== 'age_at_death',
      "required": "",
      "min": "20",
      "name": "life_age_at_death",
      "type": "number"
    },
    domProps: {
      "value": (_vm.ageAtDeath)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtDeath = _vm._n($event.target.value)
      }, _vm.calcAgeAtDeath],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.innerLifeExpectancy.method !== 'enter_date') ? _c('control', {
    attrs: {
      "label": "Expected End of Life Date",
      "for": "life_date_of_death",
      "icon-space": !_vm.dayOne
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "life_date_of_death",
      "disabled": "",
      "required": ""
    },
    domProps: {
      "value": _vm.dateOfDeath
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('life_date_of_death') &&
        (_vm.innerLifeExpectancy.method == 'percentage_reduction_in_normal_life_expectancy' ||
          _vm.innerLifeExpectancy.method == 'percentage_of_normal_life_expectancy')
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'life_age_at_death_modal_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70758bcc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LifeExpectancy.vue
// module id = 1741
// module chunks = 0